import React from 'react'
import { Chip, Paper, Stack, Typography } from '@mui/material'
import { amber, blueGrey, grey, purple, red } from '@mui/material/colors'
import * as api from 'common/api'
import { useGlobalState } from 'state'
import { HashMap } from 'common/types'

type AreaStatus = {
  area: string
  alerts: string[]
}

export const JmaAlertStatus = () => {
  const state = useGlobalState()
  const [areaStatuses, setAreaStatuses] = React.useState<AreaStatus[]>([])

  React.useEffect(() => {
    fetchMessages()
  }, [state.app.baseDate])

  const fetchMessages = async (): Promise<void> => {
    const res = await api.get('/alert/status', {
      point: 'JPGA',
      city: '2210001,2210002',
      date: state.app.getFormattedBaseDate()
    })
    if (res === null) {
      setAreaStatuses([])
      return
    }
    const isSameSet = (arr1: string[], arr2: string[]) => {
      const set1 = new Set(arr1)
      const set2 = new Set(arr2)
      return set1.size === set2.size && [...set1].every(v => set2.has(v))
    }
    const targets: AreaStatus[] = []
    res.forEach((row: HashMap) => {
      row.cities.forEach((city: HashMap) => {
        const finded = targets.find(t => isSameSet(t.alerts, city.alerts))
        if (finded) {
          finded.area += `, ${city.name}`
        } else {
          targets.push({
            area: city.name,
            alerts: city.alerts
          })
        }
      })
    })
    setAreaStatuses(targets)
  }

  const getStatusColor = (alert: string) => {
    if (alert.includes('特別警報')) {
      return grey[900]
    } else if (alert.includes('危険警報')) {
      return purple[600]
    } else if (alert.includes('警報')) {
      return red[600]
    } else if (alert.includes('注意報')) {
      return amber[700]
    } else {
      return grey[600]
    }
  }

  return (
    <Stack px={1}>
      <Paper sx={{p: 1, bgcolor: blueGrey[900], borderColor: grey[600]}} variant='outlined'>
        <Typography
          variant='body2'
          sx={{ color: grey[300], fontSize: 12 }}
          textAlign={'center'}
          mb={areaStatuses.length > 0 ? 1 : 0}
        >
          { areaStatuses.length > 0 ? '発表中の警報・注意報' : '発表中の警報・注意報はありません' }
        </Typography>
        <Stack spacing={1}>
          { areaStatuses.map((areaStatus, index) => {
            return (
              <Stack key={index} spacing={0.5}>
                <Typography
                  variant='body2'
                  sx={{
                    color: grey[300],
                    fontSize: 11,
                    lineHeight: 1.1,
                    whiteSpace: 'normal',
                    wordBreak: 'break-all',
                    overflowWrap: 'anywhere'
                  }}
                >
                  {areaStatus.area}
                </Typography>
                <Stack key={index} sx={{backgroundColor: 'transparent'}} direction='row' flexWrap='wrap'>
                  { areaStatus.alerts.map((alert, index) => {
                    return <Chip
                      key={index}
                      label={alert}
                      size='small'
                      sx={{
                        color: grey[50],
                        backgroundColor: getStatusColor(alert),
                        mr: 0.5,
                        mb: 0.5
                      }}
                    />
                  }) }
                </Stack>
              </Stack>
          )}
        ) }
        </Stack>

      </Paper>
    </Stack>
  )
}
